module.exports = __webpack_public_path__ + "media/cskh.bf026223.wav";